import { makeStyles } from "@fluentui/react-components";

export const useYellowpadPlaybooksStyles = makeStyles({
  container: {
    marginTop: "1.5rem",
  },
});
